module.exports = __webpack_public_path__ + "static/media/chicken-wrap.ba398138.jpg";